import React from 'react';
import useInView from 'react-cool-inview';
import Slider from 'react-slick';

const sliderSettings = {
    className: "center",
    centerMode: true,
    lazyLoad: true,
    // infinite: false,
    initialSlide: 2,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                centerMode: false,
                initialSlide: 1,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ],


};
//
// const products = [
//     {
//         content: <span>Cremosso Afine 125g</span>
//     },
//     {
//         content: <span>Cremosso Căpșuni 125g</span>
//     },
//     {
//         content: <span>Cremosso Natur 125g</span>
//     },
//     {
//         content: <span>Cremosso Piersici 125g</span>
//     },
//     {
//         content: <span>Cremosso Stracciatella 125g</span>
//     },
//     {
//         content: <span>Cremosso Vișine 125g</span>
//     },
//     {
//         content: <span>Cremosso Natur 400g</span>
//     },
//     {
//         content: <span>Cremosso Pere 400g</span>
//     },
//     {
//         content: <span>Cremosso Piersici 400g</span>
//     },
//     {
//         content: <span>Cremosso Stracciatella 400g</span>
//     },
//     {
//         content: <span>Cremosso Vişine 400g</span>
//     },
//     {
//         content: <span>Cremosso Natur <span className="next-line">pachet promo 7+1</span></span>
//     },
//     {
//         content: <span>Cremosso Căpşuni şi Piersici <span className="next-line">pachet promo 7+1</span></span>
//     },
//     {
//         content: <span>Cremosso Stracciatella şi Vişine <span className="next-line">pachet promo 7+1</span></span>
//     },
// ]

let products = [

    {name: 'cremosso_afine_125g', label: 'Cremosso Afine 125g'},
    {name: 'cremosso_capsuni_125g', label: 'Cremosso Căpșuni 125g'},
    {name: 'cremosso_natur_125g', label: 'Cremosso Natur 125g'},
    {name: 'cremosso_piersici_125g', label: 'Cremosso Piersici 125g'},
    {name: 'cremosso_stracciatella_125g', label: 'Cremosso Stracciatella 125g'},
    {name: 'cremosso_visine_125g', label: 'Cremosso Vișine 125g'},
    {name: 'cremosso_natur_400g', label: 'Cremosso Natur 400g'},
    {name: 'cremosso_piersici_400g', label: 'Cremosso Piersici 400g'},
    {name: 'cremosso_stracciatella_400g', label: 'Cremosso Stracciatella 400g'},
    {
        name: 'cremosso_mousse_cherry_125g',
        label: 'Cremosso Mousse preparat aerat\n cu brânză proaspătă cu un strat\n de preparat cu vișine 125g'
    },
    {
        name: 'cremosso_mousse_strawberry_125g',
        label: 'Cremosso Mousse preparat aerat\n cu brânză proaspătă cu un strat\n de preparat cu căpșuni 125g'
    },
    {
        name: 'cremosso_natur_multipack_8_125g', label: 'Cremosso Natur\n' +
            'pachet promo 7+1'
    },
    {
        name: 'cremosso_capsuni_si_piersici_multipack_8_125g', label: 'Cremosso Căpșuni/Piersici\n' +
            'pachet promo 7+1'
    },
    {
        name: 'cremosso_stracciatella_si_visine_multipack_8_125g', label: 'Cremosso Stracciatella\n' +
            'pachet promo 7+1'
    },
];

const Products = (props: any) => {
    const {ref}: any = useInView<HTMLDivElement>({
        threshold: 0.5,
        onChange({inView}) {
            //setVisibleSection((prevState: string) => inView ? 'portofoliu' : prevState);
        }
    });

    return (
        <div className="sd-section sd-section__products" ref={ref} id="portofoliu">
            <h2 className="sd-section__title">PORTOFOLIU</h2>

            {/*@ts-ignore*/}
            <Slider {...sliderSettings} >
                {products.map((content: any, i) => {
                    return (
                        <div className={`sd-product`} key={`${content.name}`}>
                            <div className={`product ${content.name}`}>
                            </div>
                            <p className="name">{content.label}</p>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
};

export default Products;
